import { createApp } from "vue";
import App from "./App.vue";
import router from "./router";
import { createPinia } from "pinia";
import "@/assets/tailwind.css";
import VueDatePicker from "@vuepic/vue-datepicker";
import "@vuepic/vue-datepicker/dist/main.css";
import PrimeVue from "primevue/config";
import MultiSelect from "primevue/multiselect";
import Tailwind from "primevue/passthrough/tailwind";
import highcharts from "highcharts-vue";
import Toast, { POSITION } from "vue-toastification";
import "vue-toastification/dist/index.css";
import RedirectIcon from "./views/dashboard/Icon/RedirectIcon.vue";
const pinia = createPinia();
const app = createApp(App);
app.use(pinia);
app.use(router);
app.use(Toast, {
  position: POSITION.TOP_RIGHT,
  timeout: 3000,
  closeOnClick: true,
  pauseOnHover: false,
  draggable: false,
  hideProgressBar: true,
  transition: "Vue-Toastification__fade", // smooth fade in/out
  maxToasts: 3,
  newestOnTop: true,
});
app.use(PrimeVue, { unstyled: true, pt: Tailwind });
app.component("MultiSelect", MultiSelect);
app.component("VueDatePicker", VueDatePicker);
app.component("highcharts", highcharts);
app.component("RedirectIcon", RedirectIcon);
app.mount("#app");
